// @flow
import * as React from 'react';
import last from 'lodash/last';
import styles from './styles';

type Props = {
  preferredSize: number,
  image?: Object,
  handleOnLoad?: Function | null,
  isHero?: boolean,
  mustBeShown?: boolean,
  dataTest: ?string,
};

function getBiggerImageKeyByPreferredSize(image: Object, preferredSize: number) {
  const preferredAndLowerSizesKeys = Object.keys(image).filter(
    key => parseInt(key, 10) <= preferredSize
  );

  return last(preferredAndLowerSizesKeys);
}

function Image({ handleOnLoad, image, preferredSize, isHero, mustBeShown, dataTest }: Props) {
  if (!image) {
    return null;
  }

  const imageKey = getBiggerImageKeyByPreferredSize(image, preferredSize);

  const imageSrc = image[imageKey];
  return (
    <React.Fragment>
      <img
        src={imageSrc}
        className={`image-wrapper ${imageKey === '6' ? 'is-maker' : ''} ${
          isHero ? 'is-hero' : ''
        } ${mustBeShown ? '' : 'hidden'}`}
        onLoad={handleOnLoad}
        itemProp="image"
        data-test={dataTest}
      />
      <style jsx>{styles}</style>
    </React.Fragment>
  );
}

Image.defaultProps = {
  image: null,
  isHero: false,
  handleOnLoad: null,
  dataTest: null,
  mustBeShown: true,
};

export default Image;



// WEBPACK FOOTER //
// ./app/components/shared/Images/Image/index.js